import { defineComponent as _defineComponent } from 'vue'
import Footer from "@/components/layout/Footer.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'InvitationLayout',
  props: {
  logoUrl: {
    required: false,
    type: String,
    default: "/logo_red.svg",
  },
  title: {
    required: false,
    type: String,
    default: "Join Peralta in three simple steps",
  },
},
  setup(__props) {



return { __sfc: true,Footer }
}

})